import React from "react";
// ANT DESIGN COMPONENTS
import { Tag } from "antd";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import MonitoringHeartBeat from "../monitoring/MonitoringHeartBeat";
// INTERFACES
import { ServerInterface } from "../../../interfaces/Server.interface";
import { RootState } from "../../../app/store";

function ControlPanelBankHeader({ liftVip, server }: { liftVip: any; server: ServerInterface }) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { bankSelected } = useSelector((state: RootState) => state.monitoring);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div
      className={`monitoringView__controlPanel__${theme} generalStyles__spaceBetween  `}
      style={{ padding: "20px" }}
    >
      <div className="generalStyles__flex" style={{ marginTop: "5px" }}>
        <MonitoringHeartBeat bankId={String(bankSelected.id ?? "")} type="TOOLTIP" />
        <div>
          <div>
            <h3>{server?.org?.name ?? ""}</h3>
          </div>
          <div>
            <h5 className="generalStyles__info" style={{ marginTop: "-15px" }}>
              {bankSelected.name}
            </h5>
            <span>{server.fbEnabled ? "FB" : "CMD"}</span>
          </div>
        </div>
      </div>
      <div className="generalStyles__flex mt-2">
        {liftVip && liftVip.id && liftVip.id !== "" && (
          <>
            <div>
              <h3>Car VIP:</h3>
            </div>
            <div className="generalStyles__mlFix">
              <Tag
                color={liftVip && liftVip.name ? "gold" : "gray"}
                className="generalStyles__width100px generalStyles__textCenter mt-1"
              >
                {liftVip && liftVip.name ? liftVip.name : "--"}
              </Tag>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ControlPanelBankHeader;
